import { render } from "./dkitchen.vue?vue&type=template&id=dd4075dc&scoped=true"
const script = {}

import "./dkitchen.vue?vue&type=style&index=0&id=dd4075dc&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4075dc"]])

export default __exports__